export default __webpack_public_path__ + "static/media/Dr._A_Granger_IMG_003.9c472970.jpg";